(function () {
    const initProductAccordion = () => {
        $(".about__accordion-toggle").click(function () {
            if (!$(this).hasClass("active")) {
                $(this).addClass("active");
                $(this).siblings(".about__accordion-description").eq($(this).index()).stop().slideDown(300);
            } else {
                $(this).removeClass("active");
                $(this).siblings(".about__accordion-description").stop().slideUp(300);
            }
        });
    }; 

    const initZoomImage = () => {
        const imagesWrapper = document.querySelector(".product-media-modal__content");
        if (!imagesWrapper) return;
        const images = imagesWrapper.querySelectorAll(".js-image-zoom");
        images.forEach((el) => {
            el.addEventListener("click", (e) => {
                imagesWrapper.classList.toggle("zoom");
            });
        });
    };

    const revealPopup = () => {
        const stickyBar = document.querySelector('.product__popup');
        const secondSection = document.querySelector('.product-section + section');
        const footer = document.querySelector('footer');
        if (!stickyBar || !secondSection || !footer) return;

        const getOffset = (element) => {
            const rect = element.getBoundingClientRect();
            return rect.top + window.scrollY;
        };
        const secondSectionMid = getOffset(secondSection);
        const footerTop = getOffset(footer);
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;
            stickyBar.classList[activeOffset ? "add" : "remove"]('active');
        };
        handleScroll();
    };

    document.addEventListener('scroll', () => revealPopup());
    document.addEventListener("shopify:section:load", function () {
        initProductAccordion();
        initZoomImage();
        revealPopup();
    });
    initProductAccordion();
    initZoomImage();
    revealPopup();
})();

class FloatedForm extends HTMLElement {
    constructor() {
        super();
        this.renderForm();
    }

    renderForm() {
        fetch(this.getAttribute("data-product-url"))
            .then((response) => response.text())
            .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
                this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');
                this.preventDuplicatedIDs();
                this.removeDOMElements();
                this.setInnerHTML(this, this.productElement.innerHTML);
                if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
                if (window.ProductModel) window.ProductModel.loadShopifyXR();
                this.showMoreFields();
            })
            .finally(() => {
                const selectDropdown = () => {
                    $(".product__popup .product-form__controls--dropdown").each(function () {
                        const elListItem = $(this).find(".dropdown-select ul li");
                        const elItem = $(this).find(".dropdown-select ul");
                        const selectedText = $(this).find(".dropdown-select .select-label");
                        selectedText.on("click", function (e) {
                            elItem.toggleClass("active");
                            if (elItem.hasClass("active")) {
                                e.stopPropagation();
                                $(document).click(function () { elItem.removeClass("active"); });
                            }
                        });
                        elListItem.on("click", function () {
                            selectedText.find("span").text($(this).text()).attr("title", $(this).text());
                            elItem.removeClass("active");
                            document.activeElement.blur();
                        });
                    });
                };
                selectDropdown();
            });
    }

    setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll("script").forEach((oldScriptTag) => {
            const newScriptTag = document.createElement("script");
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }

    preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${sectionId}`);
        if (this.productElement.querySelectorAll("variant-selects")) {
            this.productElement.querySelectorAll("variant-selects").forEach((radio) => {
                radio.dataset.originalSection = sectionId;
            });
        }
        if (this.productElement.querySelectorAll("variant-radios")) {
            this.productElement.querySelectorAll("variant-radios").forEach((radio) => {
                radio.dataset.originalSection = sectionId;
            });
        }
    }

    removeDOMElements() {
        const text = this.productElement.querySelector(".product__text"); if (text) text.remove();
        const tags = this.productElement.querySelector(".product__tags"); if (tags) tags.remove();
        const title = this.productElement.querySelector(".product__title__wrapper"); if (title) title.remove();
        const badges = this.productElement.querySelector(".product__custom-badges"); if (badges) badges.remove();
        const price = this.productElement.querySelector(".price-wrapper"); if (price) price.remove();
        const description = this.productElement.querySelector(".product__description"); if (description) description.remove();
        const sku = this.productElement.querySelector(".product__sku"); if (sku) sku.remove();
        const inventory = this.productElement.querySelector(".product__inventory"); if (inventory) inventory.remove();
        const pickupAvailability = this.productElement.querySelector("pickup-availability"); if (pickupAvailability) pickupAvailability.remove();
        const customLiquid = this.productElement.querySelector(".custom-liquid"); if (customLiquid) customLiquid.remove();
        const complementary = this.productElement.querySelector("product-recommendations"); if (complementary) complementary.remove();
        const shareButtons = this.productElement.querySelector(".share-buttons"); if (shareButtons) shareButtons.remove();
        const productModal = this.productElement.querySelectorAll(".product-popup");
        productModal.forEach((advantage) => advantage.remove());
        const floatedForm = this.productElement.querySelector("floated-form"); if (floatedForm) floatedForm.remove();
    }

    showMoreFields() {
        $(".js-show-more").click(function (e) {
            e.preventDefault();
            $(this).siblings("input").removeClass("hidden");
            $(this).siblings("label").removeClass("hidden");
            $(this).remove();
        });
    }
}

customElements.define("floated-form", FloatedForm);


// ===== PERSONALISE IT PREVIEW =====
window.initPersonalisePreview = function () {
    const toggleBtn = document.getElementById('toggle-personalise-btn');
    const form = document.getElementById('personalise-form');
    const nameInput = document.getElementById('full-name-input');

    // 🎯 SYNC VARIANT OPTIONS TO PROPERTIES (Blazer & Trousers)
    function syncVariantOptionsToProperties(variantId) {
        // Only run if hidden inputs exist (custom-double-sizing products)
        const blazerInput = document.getElementById('property-blazer-size');
        const trousersInput = document.getElementById('property-trousers-size');
        
        if (!blazerInput && !trousersInput) return;

        if (!variantId) {
            variantId = document.querySelector('form[id^="product-form"] input[name="id"]')?.value;
        }
        if (!variantId) return;

        fetch(`/variants/${variantId}.js`)
            .then(res => res.json())
            .then(variant => {
                // Variant title like "38 / 30" or "CS / 30"
                const titleParts = variant.title.split('/').map(p => p.trim());
                
                if (titleParts.length === 2) {
                    if (blazerInput) {
                        blazerInput.value = titleParts[0];
                        blazerInput.disabled = false;
                    }
                    if (trousersInput) {
                        trousersInput.value = titleParts[1];
                        trousersInput.disabled = false;
                    }
                    console.log('✅ Properties synced → Blazer:', titleParts[0], '| Trousers:', titleParts[1]);
                }
            })
            .catch(err => console.error('Variant sync failed:', err));
    }

    // Run on page load
    document.addEventListener('DOMContentLoaded', function() {
        syncVariantOptionsToProperties();
    });

    // Listen to variant change (theme event or custom)
    document.addEventListener('variant:change', function(e) {
        syncVariantOptionsToProperties(e.detail?.variantId);
    });

    // Also listen to form id input change
    const productIdInput = document.querySelector('form[id^="product-form"] input[name="id"]');
    if (productIdInput) {
        productIdInput.addEventListener('change', function() {
            syncVariantOptionsToProperties(this.value);
        });
    }

    // Fallback: poll for variant change every time select/radio changes
    document.addEventListener('change', function(e) {
        if (e.target.name === 'id' || e.target.matches('input[type="radio"][name*="size"], input[type="radio"][name*="Size"]')) {
            setTimeout(() => syncVariantOptionsToProperties(), 100);
        }
    });

    // 🎯 HIDE TYPE OPTION
    function hideTypeOption() {
        let hiddenCount = 0;
        const fieldsets = document.querySelectorAll('fieldset');
        fieldsets.forEach(fs => {
            const legend = fs.querySelector('legend, .form__label, .product-form__label');
            if (legend) {
                const text = legend.textContent.trim().toLowerCase();
                if (text === 'type' || text === 'personalization' || text.includes('personalization')) {
                    fs.style.display = 'none';
                    fs.setAttribute('data-hidden-by-personalise', 'true');
                    hiddenCount++;
                }
            }
        });
        const controlDivs = document.querySelectorAll('.product-form__controls, .product-form__input');
        controlDivs.forEach(div => {
            const label = div.querySelector('.form__label, .product-form__label, legend, label');
            if (label) {
                const text = label.textContent.trim().toLowerCase();
                if (text === 'type' || text === 'personalization') {
                    div.style.display = 'none';
                    div.setAttribute('data-hidden-by-personalise', 'true');
                    hiddenCount++;
                }
            }
        });
        const variantRadios = document.querySelectorAll('variant-radios, variant-selects');
        variantRadios.forEach(vr => {
            const legends = vr.querySelectorAll('legend, .form__label');
            legends.forEach(legend => {
                const text = legend.textContent.trim().toLowerCase();
                if (text === 'type' || text === 'personalization') {
                    const parentFieldset = legend.closest('fieldset') || legend.parentElement;
                    if (parentFieldset) {
                        parentFieldset.style.display = 'none';
                        parentFieldset.setAttribute('data-hidden-by-personalise', 'true');
                        hiddenCount++;
                    }
                }
            });
        });
    }

    if (toggleBtn && form) {
        hideTypeOption();
        document.addEventListener('shopify:section:load', hideTypeOption);

        // SMART CONTRAST DETECTOR
        function getSmartTextColor(colorStr) {
            if (!colorStr) return '#111111';
            colorStr = colorStr.trim();
            let hex = colorStr.replace('#', '');
            if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            if (hex.length === 6 && /^[0-9A-F]{6}$/i.test(hex)) {
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);
                const brightness = (r * 299 + g * 587 + b * 114) / 1000;
                return brightness < 128 ? '#FFFFFF' : '#111111';
            }
            return colorStr.startsWith('#') ? colorStr : '#' + colorStr;
        }

        function activateLastMainSlide() {
            const swiperContainer = document.querySelector('.js-media-list.swiper, .product__media-list.swiper, .swiper');
            if (swiperContainer && swiperContainer.swiper) {
                const totalSlides = swiperContainer.swiper.slides.length;
                swiperContainer.swiper.slideTo(totalSlides - 1, 400);
            } else {
                const thumbSlides = document.querySelectorAll('.product__media-sublist-outer .swiper-slide, .thumbnail-list .swiper-slide');
                if (thumbSlides.length > 0) thumbSlides[thumbSlides.length - 1].click();
            }
        }

        function getLastMainMediaImage() {
            const activeSlideImg = document.querySelector('.swiper-slide-active img, .is-active img, .product__media-item.is-active img');
            if (activeSlideImg) return activeSlideImg;
            const lastSlideImg = document.querySelector('.swiper-wrapper .product__media-item:last-child img, .swiper-wrapper .swiper-slide:last-child img');
            if (lastSlideImg) return lastSlideImg;
            const allImages = document.querySelectorAll('.product__media-list img, .swiper-slide img, modal-opener img');
            return allImages.length > 0 ? allImages[allImages.length - 1] : null;
        }

        function getLastModalMediaImage() {
            const allModalImages = document.querySelectorAll(
                '.product-media-modal__content img.js-image-zoom, .product-media-modal__content img, .product-media-modal__item img'
            );
            return allModalImages.length > 0 ? allModalImages[allModalImages.length - 1] : null;
        }

        function getImageConfig(imgElement) {
            let x = imgElement ? imgElement.dataset.cuffX : null;
            let y = imgElement ? imgElement.dataset.cuffY : null;
            let angle = imgElement ? imgElement.dataset.cuffAngle : null;
            let color = imgElement ? imgElement.dataset.cuffColor : null;
            if (!x || !color) {
                const mainImg = getLastMainMediaImage();
                if (mainImg) {
                    x = x || mainImg.dataset.cuffX;
                    y = y || mainImg.dataset.cuffY;
                    angle = angle || mainImg.dataset.cuffAngle;
                    color = color || mainImg.dataset.cuffColor;
                }
            }
            return {
                xRatio: parseFloat(x) || 0.68,
                yRatio: parseFloat(y) || 0.54,
                angleDeg: parseFloat(angle) || 108,
                colorHex: getSmartTextColor(color)
            };
        }

        function drawNameOnMain(name) {
            const mainImage = getLastMainMediaImage();
            if (!mainImage) return;
            let canvas = document.getElementById('personalise-canvas');
            if (!canvas) {
                canvas = document.createElement('canvas');
                canvas.id = 'personalise-canvas';
                canvas.style.cssText = `position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 10;`;
            }
            if (mainImage.parentElement && canvas.parentElement !== mainImage.parentElement) {
                mainImage.parentElement.style.position = 'relative';
                mainImage.parentElement.appendChild(canvas);
            }
            const ctx = canvas.getContext('2d');
            const displayWidth = mainImage.offsetWidth || mainImage.clientWidth;
            const displayHeight = mainImage.offsetHeight || mainImage.clientHeight;
            if (displayWidth === 0 || displayHeight === 0) return;
            canvas.width = displayWidth;
            canvas.height = displayHeight;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (!name.trim()) return;
            const config = getImageConfig(mainImage);
            const x = canvas.width * config.xRatio;
            const y = canvas.height * config.yRatio;
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate((config.angleDeg * Math.PI) / 180);
            const fontSize = Math.max(20, Math.round(canvas.width * 0.055));
            ctx.font = `italic bold ${fontSize}px Georgia, serif`;
            ctx.fillStyle = config.colorHex;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            if (config.colorHex.toUpperCase() === '#FFFFFF') {
                ctx.shadowColor = 'rgba(0, 0, 0, 0.7)';
                ctx.shadowBlur = 3;
            } else {
                ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
                ctx.shadowBlur = 2;
            }
            ctx.shadowOffsetX = 1;
            ctx.shadowOffsetY = 1;
            ctx.fillText(name, 0, 0);
            ctx.restore();
        }

        function drawOnModal(name) {
            let modalCanvas = document.getElementById('personalise-modal-canvas');
            if (modalCanvas) {
                const mCtx = modalCanvas.getContext('2d');
                mCtx.clearRect(0, 0, modalCanvas.width, modalCanvas.height);
            }
            if (!name || !name.trim()) return;
            setTimeout(function () {
                const modalImg = getLastModalMediaImage();
                if (!modalImg) return;
                let modalCanvas = document.getElementById('personalise-modal-canvas');
                if (!modalCanvas) {
                    modalCanvas = document.createElement('canvas');
                    modalCanvas.id = 'personalise-modal-canvas';
                    modalCanvas.style.cssText = `position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 20;`;
                }
                const imgParent = modalImg.parentElement;
                if (imgParent && modalCanvas.parentElement !== imgParent) {
                    imgParent.style.position = 'relative';
                    imgParent.appendChild(modalCanvas);
                }
                const displayWidth = modalImg.clientWidth || modalImg.offsetWidth;
                const displayHeight = modalImg.clientHeight || modalImg.offsetHeight;
                if (displayWidth === 0 || displayHeight === 0) return;
                modalCanvas.width = displayWidth;
                modalCanvas.height = displayHeight;
                const mCtx = modalCanvas.getContext('2d');
                mCtx.clearRect(0, 0, modalCanvas.width, modalCanvas.height);
                const config = getImageConfig(modalImg);
                const mx = modalCanvas.width * config.xRatio;
                const my = modalCanvas.height * config.yRatio;
                mCtx.save();
                mCtx.translate(mx, my);
                mCtx.rotate((config.angleDeg * Math.PI) / 180);
                const mFontSize = Math.max(22, Math.round(modalCanvas.width * 0.045));
                mCtx.font = `italic bold ${mFontSize}px Georgia, serif`;
                mCtx.fillStyle = config.colorHex;
                mCtx.textAlign = 'center';
                mCtx.textBaseline = 'middle';
                if (config.colorHex.toUpperCase() === '#FFFFFF') {
                    mCtx.shadowColor = 'rgba(0, 0, 0, 0.7)';
                    mCtx.shadowBlur = 3;
                } else {
                    mCtx.shadowColor = 'rgba(0, 0, 0, 0.2)';
                    mCtx.shadowBlur = 2;
                }
                mCtx.shadowOffsetX = 1;
                mCtx.shadowOffsetY = 1;
                mCtx.fillText(name, 0, 0);
                mCtx.restore();
            }, 400);
        }

        let variantMap = {};

        function findVariants() {
            variantMap = {};
            const pathParts = window.location.pathname.split('/');
            const productHandle = pathParts[pathParts.indexOf('products') + 1];
            if (!productHandle) return;

            fetch(`/products/${productHandle}.js`)
                .then(res => res.json())
                .then(data => {
                    data.variants.forEach(v => {
                        const title = (v.title || '').toLowerCase();
                        const id = String(v.id);
                        const parts = title.split('/').map(p => p.trim());
                        if (parts.length !== 2) return;
                        const size = parts[0];
                        const type = parts[1];
                        if (!variantMap[size]) variantMap[size] = {};
                        variantMap[size][type] = id;
                    });
                    window.variantMap = variantMap;
                })
                .catch(err => console.error('Variant fetch failed:', err));
        }
        findVariants();
        document.addEventListener('shopify:section:load', findVariants);

        function getSelectedSize() {
            const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
            for (const radio of checkedRadios) {
                const name = (radio.name || '').toLowerCase();
                if (name.includes('size')) return radio.value.toLowerCase();
            }
            const fieldsets = document.querySelectorAll('fieldset, .product-form__input');
            for (const fs of fieldsets) {
                if (fs.getAttribute('data-hidden-by-personalise') === 'true') continue;
                const legend = fs.querySelector('legend, .form__label');
                if (legend && legend.textContent.toLowerCase().includes('size')) {
                    const checked = fs.querySelector('input[type="radio"]:checked');
                    if (checked) return checked.value.toLowerCase();
                }
            }
            const firstChecked = document.querySelector('input[type="radio"]:checked');
            if (firstChecked) return firstChecked.value.toLowerCase();
            return null;
        }

        function changeVariant(variantId) {
            if (!variantId) return;
            variantId = String(variantId);

            const formInputs = document.querySelectorAll('form[id^="product-form"] input[name="id"]');
            formInputs.forEach(input => {
                input.value = variantId;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            });

            const hiddenInputs = document.querySelectorAll('input[name="id"][type="hidden"]');
            hiddenInputs.forEach(input => {
                input.value = variantId;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            });

            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url.toString());

            updatePriceDisplay(variantId);
            
            // 🎯 SYNC PROPERTIES
            syncVariantOptionsToProperties(variantId);

            document.dispatchEvent(new CustomEvent('variant:change', {
                detail: { variantId: variantId }
            }));
        }

        function updatePriceDisplay(variantId) {
            fetch(`/variants/${variantId}.js`)
                .then(res => res.json())
                .then(variant => {
                    const shopCurrency = window.Shopify?.currency || {};
                    const activeCurrency = shopCurrency.active || 'INR';
                    const rate = shopCurrency.rate || 1;
                    const basePrice = variant.price / 100;
                    const convertedPrice = basePrice;
                    const formattedPrice = formatMoney(convertedPrice, activeCurrency);

                    const priceSelectors = [
                        '.price__container .price-item',
                        '.price-item--regular',
                        '.price-item--sale',
                        '.product__price',
                        '[data-product-price]',
                        '.price'
                    ];
                    priceSelectors.forEach(selector => {
                        document.querySelectorAll(selector).forEach(el => {
                            el.textContent = formattedPrice;
                        });
                    });
                })
                .catch(err => console.error('Price update failed:', err));
        }

        function formatMoney(amount, currencyCode) {
            const symbols = {'INR':'₹','AED':'AED','USD':'$','EUR':'€','GBP':'£','CAD':'CA$','AUD':'A$','SGD':'S$','JPY':'¥'};
            const symbol = symbols[currencyCode] || currencyCode;
            let formattedAmount = '';
            if (currencyCode === 'INR') {
                const parts = amount.toFixed(2).split('.');
                const intPart = parts[0];
                const decPart = parts[1];
                let formattedInt = '';
                if (intPart.length > 3) {
                    const lastThree = intPart.slice(-3);
                    const rest = intPart.slice(0, -3);
                    formattedInt = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
                } else {
                    formattedInt = intPart;
                }
                formattedAmount = `${formattedInt}.${decPart}`;
            } else {
                formattedAmount = amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
            }
            return `${formattedAmount} ${symbol}`;
        }

        function changeToPersonalized() {
            const selectedSize = getSelectedSize();
            if (!selectedSize) return false;
            if (!variantMap[selectedSize]) return false;
            const targetVariantId = variantMap[selectedSize]['personalized']
                || variantMap[selectedSize]['personalised']
                || variantMap[selectedSize]['personalize'];
            if (!targetVariantId) return false;
            changeVariant(targetVariantId);
            return true;
        }

        function changeToBase() {
            const selectedSize = getSelectedSize();
            if (!selectedSize) return;
            if (!variantMap[selectedSize]) return;
            const targetVariantId = variantMap[selectedSize]['base']
                || variantMap[selectedSize]['standard']
                || variantMap[selectedSize]['default'];
            if (!targetVariantId) return;
            changeVariant(targetVariantId);
        }

        toggleBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const isHidden = (form.style.display === 'none' || form.style.display === '');
            const chargeInput = document.getElementById('personalization-charge-input');

            if (isHidden) {
                // Open Personalisation
                form.style.display = 'block';
                toggleBtn.textContent = 'REMOVE PERSONALISATION';
                if (nameInput) {
                    nameInput.removeAttribute('disabled');
                    nameInput.focus();
                }
                if (chargeInput) chargeInput.removeAttribute('disabled');
                activateLastMainSlide();
                changeToPersonalized();
                setTimeout(function () {
                    if (nameInput && nameInput.value) {
                        drawNameOnMain(nameInput.value.toUpperCase().slice(0, 3));
                        drawOnModal(nameInput.value.toUpperCase().slice(0, 3));
                    }
                }, 450);
            } else {
                // Remove Personalisation
                form.style.display = 'none';
                if (nameInput) {
                    nameInput.value = '';
                    nameInput.setAttribute('disabled', 'true');
                }
                if (chargeInput) chargeInput.setAttribute('disabled', 'true');
                toggleBtn.textContent = 'PERSONALISE IT';
                changeToBase();
                drawNameOnMain('');
                drawOnModal('');
                updatePersonalizationPrice('');
            }
        });

        if (nameInput) {
            nameInput.addEventListener('input', function () {
                const val = this.value.toUpperCase().slice(0, 3);
                this.value = val;
                const chargeInput = document.getElementById('personalization-charge-input');

                if (val.length > 0) {
                    toggleBtn.textContent = 'REMOVE PERSONALISATION';
                    changeToPersonalized();
                    if (chargeInput) chargeInput.removeAttribute('disabled');
                    drawNameOnMain(val);
                    drawOnModal(val);
                    updatePersonalizationPrice(val);
                } else {
                    // Empty input: reset button, price and cuff
                    toggleBtn.textContent = 'PERSONALISE IT';
                    changeToBase();
                    if (chargeInput) chargeInput.setAttribute('disabled', 'true');
                    drawNameOnMain('');
                    drawOnModal('');
                    updatePersonalizationPrice('');
                }
            });

            nameInput.addEventListener('blur', function () {
                if (!this.value || this.value.trim().length === 0) {
                    this.value = '';
                    toggleBtn.textContent = 'PERSONALISE IT';
                    changeToBase();
                    const chargeInput = document.getElementById('personalization-charge-input');
                    if (chargeInput) chargeInput.setAttribute('disabled', 'true');
                    drawNameOnMain('');
                    drawOnModal('');
                    updatePersonalizationPrice('');
                }
            });
        }

        function updatePersonalizationPrice(initials) {
            let priceInput = document.querySelector('input[name="properties[_personalization_price]"]');
            if (initials && initials.length >= 1) {
                if (!priceInput) {
                    priceInput = document.createElement('input');
                    priceInput.type = 'hidden';
                    priceInput.name = 'properties[_personalization_price]';
                    priceInput.id = 'personalization-price-hidden';
                    const productForm = document.querySelector('form[id^="product-form"]');
                    if (productForm) productForm.appendChild(priceInput);
                }
                priceInput.value = '5000';
                priceInput.disabled = false;
            } else {
                if (priceInput) priceInput.disabled = true;
            }
        }

        window.addEventListener('resize', function () {
            if (nameInput) {
                drawNameOnMain(nameInput.value.toUpperCase().slice(0, 3));
                drawOnModal(nameInput.value.toUpperCase().slice(0, 3));
            }
        });

        document.addEventListener('click', function (e) {
            if (!nameInput) return;
            if (
                e.target.classList.contains('product__modal-opener') ||
                e.target.closest('.product__modal-opener') ||
                e.target.classList.contains('js-image-zoom') ||
                e.target.closest('.slider-button') ||
                e.target.closest('.product-media-modal__toggle')
            ) {
                drawOnModal(nameInput.value.toUpperCase().slice(0, 3));
            }
        });

        // 🎯 CLICK COORDINATES LOGGER (Naya add kiya gaya hai)
        document.addEventListener('click', function (e) {
            const img = e.target.closest('img');
            if (!img) return;

            // Sirf product images par kaam karega
            if (!img.closest('.product__media-list') && 
                !img.closest('.swiper-slide') && 
                !img.closest('.product-media-modal__content') && 
                !img.classList.contains('js-image-zoom')) {
                return;
            }

            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            // Check karein ki click image ke andar hi hua hai
            if (x >= 0 && y >= 0 && x <= rect.width && y <= rect.height) {
                const xRatio = (x / rect.width).toFixed(2);
                const yRatio = (y / rect.height).toFixed(2);
                
                // Existing config se angle aur color nikalna
                const config = getImageConfig(img);
                
                // Console mein exact format mein print karna
                console.log(`%c${xRatio}, ${yRatio}, ${config.angleDeg}, ${config.colorHex}`, 
                    'background: #222; color: #bada55; padding: 4px; border-radius: 4px; font-weight: bold;');
            }
        });
    }
};

// Auto-initialize
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        if (typeof window.initPersonalisePreview === 'function') window.initPersonalisePreview();
    });
} else {
    if (typeof window.initPersonalisePreview === 'function') window.initPersonalisePreview();
}
document.addEventListener('shopify:section:load', function () {
    if (typeof window.initPersonalisePreview === 'function') window.initPersonalisePreview();
});